export default __webpack_public_path__ + "static/media/Tasks.a03c5093.svg";